
import { Record } from 'immutable'
const Account = Record({
  email:null,
  password:null,
  password_confirmation:null
});
export default Account;
